import type { Employee } from '../data/databaseSchema';

export type EmployeeRoleDisplayLookup = (stored: unknown) => string;

export function createEmployeeRoleDisplayLookup(
  employees: Employee[] | undefined
): EmployeeRoleDisplayLookup {
  const exact = new Map<string, string>();
  const lower = new Map<string, string>();
  for (const e of employees ?? []) {
    const id = e.employee_id?.trim() ?? '';
    if (!id) continue;
    exact.set(id, e.fullname);
    lower.set(id.toLowerCase(), e.fullname);
  }
  return (stored: unknown) => {
    if (stored === null || stored === undefined) return '-';
    const s = String(stored).trim();
    if (s === '') return '-';
    return exact.get(s) ?? lower.get(s.toLowerCase()) ?? s;
  };
}

export function employeesForProjectRoleSelect(
  employees: Employee[],
  currentValue: string
): Employee[] {
  const cur = currentValue.trim();
  const active = employees
    .filter((e) => (e.status ?? 'active') === 'active')
    .sort((a, b) => a.fullname.localeCompare(b.fullname, undefined, { sensitivity: 'base' }));
  const activeIdsLower = new Set(active.map((e) => e.employee_id.toLowerCase()));
  if (!cur || activeIdsLower.has(cur.toLowerCase())) return active;
  const resolved = employees.find(
    (e) => e.employee_id === cur || e.employee_id.toLowerCase() === cur.toLowerCase()
  );
  if (resolved && !activeIdsLower.has(resolved.employee_id.toLowerCase())) {
    return [resolved, ...active.filter((e) => e.employee_id !== resolved.employee_id)];
  }
  return active;
}

export function projectRoleValueMatchesEmployee(employees: Employee[], stored: string): boolean {
  const cur = stored.trim();
  if (!cur) return false;
  return employees.some(
    (e) => e.employee_id === cur || e.employee_id.toLowerCase() === cur.toLowerCase()
  );
}
